import { Autocomplete, Box, Paper, TextField } from "@mui/material";
import { AMERICAS_COUNTRIES } from "../../config/config";
import { formatPhoneNumber } from "../../utils/StringTool";

export default function PhoneInput({
  phone,
  setPhone,
  country,
  setCountry,
}: any) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Autocomplete
        options={AMERICAS_COUNTRIES}
        value={country}
        onChange={(_, value) => setCountry(value)}
        sx={{
          width: 76,
          "& .MuiInputBase-root": { pl: "10px", pr: "5px" },
        }}
        disableClearable
        renderOption={(props, option) => {
          const { key, ...rest } = props;
          return (
            <Box
              component="li"
              key={option.code + option.label}
              {...rest}
              sx={{ display: "flex", alignItems: "center", gap: 1, width: 180 }}
            >
              <img
                src={option.flag}
                alt={option.label}
                width={22}
                style={{
                  marginRight: 0,
                  borderRadius: 3,
                  boxShadow: "0 1px 2px #0001",
                }}
                loading="lazy"
              />
              {/* <span style={{ fontWeight: 600 }}>{option.code}</span> */}
              <span style={{ marginLeft: 6, color: "#888", fontSize: 14 }}>
                {option.label}
              </span>
            </Box>
          );
        }}
        getOptionLabel={(option) => option.code}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              readOnly: true,
              style: { cursor: "pointer" },
            }}
            variant="outlined"
            sx={{
              "& .MuiInputBase-input": {
                textAlign: "center",
                fontWeight: 600,
                fontSize: 16,
                pl: 0,
              },
              "& fieldset": { border: "none" },
              bgcolor: "#F6F8FB",
              width: 90,
              p: 0,
            }}
          />
        )}
        PaperComponent={({ children, ...props }) => (
          <Paper {...props} sx={{ minWidth: 140 }}>
            {children}
          </Paper>
        )}
      />
      <TextField
        placeholder="300 123 4567"
        value={formatPhoneNumber(phone)}
        onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
        autoFocus
        inputProps={{
          maxLength: 15,
          inputMode: "numeric",
        }}
      />
    </Box>
  );
}
